export function removerCaracteresEspeciais(texto: string): string {
  if (!texto) return texto;

  const caracteresEspeciais = /[^a-z\d]/gi;

  return texto.toString().replace(caracteresEspeciais, '');
}
export function removerCaracteresEspeciaisEAcentos(texto: string): string {
  // Remove os acentos
  const textoSemAcentos = texto
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

  // Remove caracteres especiais e mantém espaços
  return textoSemAcentos.replace(/[^\w\s]/g, '');
}
export function formatTextToSearch(texto: string): string {
  if (!texto) return texto;

  const textLowerCase = texto.toLowerCase();

  const caracteresEspeciais = /[^a-z\d\s]/gi;

  return textLowerCase.toString().replace(caracteresEspeciais, '');
}
export function verifyIfContainDate(
  dateString: string,
  filterValue: string
): boolean {
  const dataSemHoras = dateString.split('T')[0];

  const dataAjustada = dataSemHoras?.split('-').reverse().join('/');

  const dataSemCaracteresEspeciais = removerCaracteresEspeciais(dataAjustada!);

  if (dataSemCaracteresEspeciais.includes(filterValue)) {
    return true;
  }

  return false;
}
export function capitalizarPrimeiraLetraCadaPalavra(text: string): string {
  if (!text) return text;

  return text
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function converteEmNumeroOrNull(valor: string | undefined) {
  if (!isNaN(Number(valor))) {
    return Number(valor);
  }

  return undefined;
}
export function textIsBigToShow(text: string) {
  const count = text.length;

  return count > 25 ? true : false;
}
export function transformaTextoMonetarioEmNumero(
  currencyString: string
): number {
  const valorSemSimbolos = currencyString.replace(/[^\d,]/g, '');

  const valorNumerico = parseFloat(valorSemSimbolos.replace(',', ''));

  return Math.round(valorNumerico);
}

export function formatCpfToNumber(value: string): number {
  return Number(value.replace(/\D/g, ''));
}
export function parseBRLToNumber(value: string): number {
  const cleaned = value.replace(/[R$\s.]/g, '');
  const normalized = cleaned.replace(',', '.');
  const parsed = Number(normalized);

  if (isNaN(parsed)) {
    throw new Error(`Valor inválido: "${value}"`);
  }

  return parsed;
}
export function hasInvalidStrings(values: string[]): boolean {
  return values.some((value) => {
    if (typeof value !== 'string') return true;

    if (value.trim() === '') return true;

    if (value.toLowerCase() === 'nan') return true;

    if (value.toLowerCase() === 'undefined' || value.toLowerCase() === 'null')
      return true;

    return false;
  });
}
